import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import StatusBadge from "../../components/StatusBadge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { DollarSign, TrendingUp } from "lucide-react";
import api from "../../lib/api";

export default function AdminFinances() {
  const [payments, setPayments] = useState([]);

  useEffect(() => { api.get("/admin/payments").then((r) => setPayments(r.data)).catch(() => {}); }, []);

  const paid = payments.filter((p) => p.payment_status === "paid");
  const total = paid.reduce((s, p) => s + (p.amount || 0), 0);
  const byType = paid.reduce((acc, p) => { const t = p.payment_type || "PRIVATE_PAY"; acc[t] = (acc[t] || 0) + (p.amount || 0); return acc; }, {});

  return (
    <AppShell admin>
      <h1 className="font-display text-3xl font-bold text-navy">Finances</h1>
      <p className="text-slateBrand">All transactions with clear payment types and line items.</p>

      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="finance-total">
          <div className="flex items-center gap-2 text-slateBrand"><DollarSign className="h-4 w-4" /><span className="text-xs">Total Collected</span></div>
          <div className="mt-2 font-display text-2xl font-bold text-navy">${total.toLocaleString()}</div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <div className="flex items-center gap-2 text-slateBrand"><TrendingUp className="h-4 w-4" /><span className="text-xs">Private Pay</span></div>
          <div className="mt-2 font-display text-2xl font-bold text-navy">${(byType.PRIVATE_PAY || 0).toLocaleString()}</div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <div className="flex items-center gap-2 text-slateBrand"><TrendingUp className="h-4 w-4" /><span className="text-xs">Scholarship</span></div>
          <div className="mt-2 font-display text-2xl font-bold text-navy">${(byType.SCHOLARSHIP || 0).toLocaleString()}</div>
        </div>
      </div>

      <div className="mt-8 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <Table>
          <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Type</TableHead><TableHead>Payment Type</TableHead><TableHead>Line Items</TableHead><TableHead>Amount</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {payments.map((p) => (
              <TableRow key={p.id} data-testid={`finance-row-${p.id}`}>
                <TableCell className="text-sm">{new Date(p.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</TableCell>
                <TableCell className="text-sm capitalize">{p.kind}</TableCell>
                <TableCell className="text-xs">{(p.payment_type || "").replace("_", " ")}</TableCell>
                <TableCell className="text-xs text-slateBrand">{(p.line_items || []).map((l) => l.label).join(", ")}</TableCell>
                <TableCell className="font-semibold text-navy">${(p.amount || 0).toFixed(2)}</TableCell>
                <TableCell><StatusBadge status={p.payment_status} /></TableCell>
              </TableRow>
            ))}
            {payments.length === 0 && <TableRow><TableCell colSpan={6} className="py-8 text-center text-slateBrand">No transactions yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </AppShell>
  );
}
